import { Navigate, Route, Routes } from "react-router-dom";
import { useMember } from "../../context/memberContext";
import { useTranslations } from "../../hooks/useTranslations";
import { Permission } from "../../types";
import { flattenPermissions } from "../../utils";
import NavTabs from "../ui/NavTabs";
import Page from "../ui/Page";
import AccountingCharts from "./AccountingCharts";
import MonthlyAnalysis from "./MonthlyAnalysis";
import ThreeYearAnalysis from "./ThreeYearAnalysis";
import WageCostAnalysis from "./WageCostAnalysis";
import WageCostCharts from "./WageCostCharts";

const BilanzOnline = () => {
  const { i18n } = useTranslations();
  const { member } = useMember();
  const memberUserPermissions = member ? flattenPermissions(member) : [];

  const hasWageCosts = memberUserPermissions.includes(Permission.WageCostsRead);
  const hasAccountings = memberUserPermissions.includes(
    Permission.AccountingsRead,
  );

  const tabs = [
    ...(hasWageCosts
      ? [
          {
            to: "lohnkosten-aufstellung",
            text: i18n.bilanzOnline.wageCostAnalysis.title,
          },
          {
            to: "lohnkosten-grafiken",
            text: i18n.bilanzOnline.wageCostCharts.title,
          },
        ]
      : []),
    ...(hasAccountings
      ? [
          {
            to: "buchhalterische-drei-jahres-analyse",
            text: i18n.bilanzOnline.threeYearAnalysis.title,
          },
          {
            to: "buchhalterische-monats-analyse",
            text: i18n.bilanzOnline.monthlyAnalysis.title,
          },
          {
            to: "buchhalterische-kennzahlen",
            text: i18n.bilanzOnline.accountingCharts.title,
          },
        ]
      : []),
  ];
  const firstTab = tabs[0];

  return (
    <Page
      title={i18n.bilanzOnline.title}
      description={i18n.bilanzOnline.description}
    >
      <NavTabs tabs={tabs} />
      <Routes>
        {hasWageCosts && (
          <>
            <Route
              path="lohnkosten-aufstellung"
              element={<WageCostAnalysis />}
            />
            <Route path="lohnkosten-grafiken" element={<WageCostCharts />} />
          </>
        )}
        {hasAccountings && (
          <>
            <Route
              path="buchhalterische-drei-jahres-analyse"
              element={<ThreeYearAnalysis />}
            />
            <Route
              path="buchhalterische-monats-analyse"
              element={<MonthlyAnalysis />}
            />
            <Route
              path="buchhalterische-kennzahlen"
              element={<AccountingCharts />}
            />
          </>
        )}
        {firstTab && (
          <Route path="*" element={<Navigate to={firstTab.to} replace />} />
        )}
      </Routes>
    </Page>
  );
};

export default BilanzOnline;
